import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";

export default function ResetPassword() {

  const { token } = useParams();
  const navigate = useNavigate();

  const [password,setPassword] = useState("");
  const [confirmPassword,setConfirmPassword] = useState("");
  const [showPassword,setShowPassword] = useState(false);
  const [message,setMessage] = useState("");
  const [loading,setLoading] = useState(false);

  const getStrength = (pass) => {

    if(pass.length < 6) return {text:"Weak",color:"red"};
    if(pass.match(/[A-Z]/) && pass.match(/[0-9]/) && pass.length >=8)
      return {text:"Strong",color:"green"};

    return {text:"Medium",color:"orange"};
  };

  const strength = getStrength(password);

  const handleReset = async () => {

    if(password !== confirmPassword){
      setMessage("Passwords do not match");
      return;
    }

    try{

      setLoading(true);

      await api.post("/auth/reset-password",{
        token:token,
        password:password
      });

      setMessage("Password updated successfully");

      setTimeout(()=>{
        navigate("/login");
      },2000);

    }
    catch{
      setMessage("Reset link expired or invalid");
    }
    finally{
      setLoading(false);
    }
  };

  return (

    <div style={{
      height:"100vh",
      display:"flex",
      justifyContent:"center",
      alignItems:"center",
      background:"#f3f6fb"
    }}>

      <div style={{
        width:"420px",
        background:"#fff",
        padding:"40px",
        borderRadius:"12px",
        boxShadow:"0 10px 30px rgba(0,0,0,0.1)"
      }}>

        <h2 style={{textAlign:"center",marginBottom:"10px"}}>
          Reset Password
        </h2>

        <p style={{textAlign:"center",color:"#666",marginBottom:"25px"}}>
          Create a new secure password
        </p>


        {/* Password */}

        <div style={{position:"relative"}}>

          <input
            type={showPassword ? "text":"password"}
            placeholder="New Password"
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
            style={{
              width:"100%",
              padding:"12px",
              border:"1px solid #ddd",
              borderRadius:"6px"
            }}
          />

          <span
            onClick={()=>setShowPassword(!showPassword)}
            style={{
              position:"absolute",
              right:"12px",
              top:"12px",
              cursor:"pointer",
              color:"#555"
            }}
          >
            👁
          </span>

        </div>


        {/* Strength Meter */}

        {password && (
          <div style={{marginTop:"8px",marginBottom:"15px"}}>
            <span style={{color:strength.color,fontSize:"14px"}}>
              Strength: {strength.text}
            </span>
          </div>
        )}


        {/* Confirm Password */}

        <input
          type={showPassword ? "text":"password"}
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e)=>setConfirmPassword(e.target.value)}
          style={{
            width:"100%",
            padding:"12px",
            border:"1px solid #ddd",
            borderRadius:"6px",
            marginBottom:"20px"
          }}
        />


        {/* Button */}

        <button
          onClick={handleReset}
          disabled={loading}
          style={{
            width:"100%",
            padding:"12px",
            background:"#2563eb",
            color:"#fff",
            border:"none",
            borderRadius:"6px",
            fontWeight:"bold",
            cursor:"pointer",
            transition:"0.3s",
            transform: loading ? "scale(0.98)" : "scale(1)"
          }}
        >
          {loading ? "Updating..." : "Update Password"}
        </button>


        {/* Alert Message */}

        {message && (
          <div style={{
            marginTop:"20px",
            padding:"10px",
            borderRadius:"6px",
            textAlign:"center",
            background:"#eef2ff",
            color:"#333",
            fontSize:"14px"
          }}>
            {message}
          </div>
        )}

      </div>

    </div>

  );
}